import { useEffect } from "react";
import { motion } from "framer-motion";

export const Preloader = ({ onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, 2300);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-espresso"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
    >
      <svg viewBox="0 0 100 100" className="mb-7 h-16 w-16">
        <motion.path
          d="M27 34 L50 78 L73 34"
          fill="none"
          stroke="#C0A062"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 1.1, ease: "easeInOut", delay: 0.2 }}
        />
        <motion.path
          d="M38 24 H62"
          fill="none"
          stroke="#C0A062"
          strokeWidth="3"
          strokeLinecap="round"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.5, delay: 1.15 }}
        />
      </svg>
      <div className="overflow-hidden">
        <motion.h1
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.9, delay: 0.85, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-5xl tracking-[0.08em] text-ivory sm:text-6xl"
        >
          Vāsam
        </motion.h1>
      </div>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 1.45 }}
        className="mt-4 text-[10px] uppercase tracking-[0.5em] text-champagne/80"
      >
        Maison de fragrances
      </motion.p>
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.8, delay: 0.3, ease: "easeInOut" }}
        className="absolute bottom-16 h-px w-40 origin-left bg-champagne/40"
      />
    </motion.div>
  );
};
